/**
 * Cards Slider Section
 * Handles horizontal scroll with progress bar
 */

(function () {
  'use strict';

  function initCardsSlider() {
    initScrollBar();
  }

  function initScrollBar() {
    const scrollContainer = document.querySelector('.js-cards-slider-scroll');
    const progressBar = document.querySelector('.cards-slider__scroll-bar-thumb');

    if (!scrollContainer || !progressBar) return;

    function updateProgressBar() {
      const scrollLeft = scrollContainer.scrollLeft;
      const scrollWidth = scrollContainer.scrollWidth;
      const clientWidth = scrollContainer.clientWidth;
      const maxScroll = scrollWidth - clientWidth;
      const trackElement = scrollContainer.closest('.cards-slider')?.querySelector('.cards-slider__scroll-bar-track');

      if (!trackElement) return;

      const trackWidth = trackElement.clientWidth;

      if (maxScroll <= 0) {
        progressBar.style.width = '100%';
        progressBar.style.left = '0%';
        return;
      }

      const thumbWidth = (clientWidth / scrollWidth) * trackWidth;
      const maxThumbPosition = trackWidth - thumbWidth;
      const scrollPosition = scrollLeft / maxScroll;
      const thumbPosition = scrollPosition * maxThumbPosition;

      progressBar.style.width = `${thumbWidth}px`;
      progressBar.style.left = `${thumbPosition}px`;
    }

    scrollContainer.addEventListener('scroll', updateProgressBar);
    window.addEventListener('resize', updateProgressBar);
    updateProgressBar();
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardsSlider);
  } else {
    initCardsSlider();
  }

  // Re-initialize on section load (Theme Editor support)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('.cards-slider')) {
        initCardsSlider();
      }
    });
  }
})();
